import { motion, useReducedMotion } from "framer-motion";

interface EmeryProps {
  message: string;
}

export function Emery({ message }: EmeryProps) {
  const prefersReducedMotion = useReducedMotion();
  return (
    <div className="flex items-start gap-3 mb-8">
      <picture className="flex-shrink-0 w-12 h-12">
        <source
          type="image/avif"
          srcSet="/emery-96.avif 1x, /emery-192.avif 2x"
        />
        <source
          type="image/webp"
          srcSet="/emery-96.webp 1x, /emery-192.webp 2x"
        />
        <img
          src="/emery-96.png"
          srcSet="/emery-96.png 1x, /emery-192.png 2x"
          alt="Emery"
          width={48}
          height={48}
          loading="lazy"
          decoding="async"
          className="rounded-full w-12 h-12 object-cover"
        />
      </picture>
      <motion.div
        className="speech-bubble flex-1"
        initial={prefersReducedMotion ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: prefersReducedMotion ? 0 : 0.3, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="text-base leading-relaxed" style={{ color: "var(--text-primary)" }}>
          {message}
        </p>
      </motion.div>
    </div>
  );
}
